module.exports = __webpack_public_path__ + "static/media/sf_1100.bc28705690265737b66f9762bfc9b6d8.png";